import { Card, Container } from 'react-bootstrap';
import '../../App.css';
import * as React from 'react';
import { Routes, Route } from 'react-router-dom';
import NavbarVerical from '../Navbar/navbarVertical';
import PageConfiuration from '../AdminPages/pagesconfiguration/PageConfiguration/page';
import CourseWiseDocument from '../AdminPages/coursewisedocuments/CourseWiseDocument/page';
import CategoryType from '../AdminPages/master/CategoryType/page';
import InstructionUpload from '../AdminPages/master/InstructionUploading/page';
import RegistrationFees from '../AdminPages/master/RegistrationFees/page';
function InstituteDashboard() {
  return (
    <>
      <>
        {/* Static Vertical Navbar */}
        <NavbarVerical />

        {/* Dynamic Content Area */}
        <div className="content-area">
          <Routes>
            {/* Default Content */}
            <Route path="/" element={<h3>Welcome to the Institute Dashboard</h3>} />
            {/* Nested Routes */}
            <Route path="/page-configuration" element={<PageConfiuration />} />
            <Route path="/course-wise-document" element={<CourseWiseDocument />} />
            <Route path="/category-type" element={<CategoryType />} />
            <Route path="/instruction-upload" element={<InstructionUpload />} />
            <Route path="/registration-fees" element={<RegistrationFees />} />

            {/* <Route path="/application-configuration" element={<CourseWiseDocument />} /> */}
          </Routes>
        </div>
      </>
    </>
  );

};

export default InstituteDashboard;